export const setFormData = (
  formData: FormData,
  data: any,
  parentKey?: string
) => {
  Object.keys(data).forEach((key) => {
    const val = data[key]; // value

    if (parentKey) key = `${parentKey}[${key}]`; // 값이 객체일때 해당객체에 접근

    if (val instanceof Object && !Array.isArray(val)) {
      return setFormData(formData, val, key);
    }

    if (Array.isArray(val)) {
      val.forEach((v, idx) => {
        if (v instanceof Object) {
          setFormData(formData, v, `${key}[${idx}]`);
        } else {
          formData.append(`${key}[${idx}]`, v);
        }
      });
    } else {
      formData.append(key, val);
    }
  });
};

export const utf8_to_b64 = (str: string) =>
  window.btoa(unescape(encodeURIComponent(str)));
